export default __webpack_public_path__ + "static/media/strip-landing.e3dd9af9.svg";